module.exports = __webpack_public_path__ + "static/media/pig.3afdeef1.svg";